import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_serial_number_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  sn_type: fromDatatype.VarcharDatatypeInterface;
  sn_id: fromDatatype.VarcharDatatypeInterface;
  sn_description: fromDatatype.TextDatatypeInterface;
  sn_option_json: fromDatatype.JsonDatatypeInterface;
  sn_property_json: fromDatatype.JsonDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  quantity_balance: fromDatatype.NumericDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  location_id: fromDatatype.VarcharDatatypeInterface;
}

export class bl_inv_serial_number_hdr_RowClass implements bl_inv_serial_number_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  sn_type: fromDatatype.VarcharDatatypeInterface;
  sn_id: fromDatatype.VarcharDatatypeInterface;
  sn_description: fromDatatype.TextDatatypeInterface;
  sn_option_json: fromDatatype.JsonDatatypeInterface;
  sn_property_json: fromDatatype.JsonDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  quantity_balance: fromDatatype.NumericDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  location_id: fromDatatype.VarcharDatatypeInterface;
}
